import axios from "axios";
import Cookies from "js-cookie";
import { withApiError } from "../utils/apiError";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

export const fetchMarkerColors = async (workflowId) => {
    const token = Cookies.get("accessToken");

    try {
        const response = await axios.get(
            `${BASE_URL}api/v1/marker-color/get-all?workflowId=${workflowId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.header.code === 600) {
            return response.data.body.value;
        }

        throw new Error("Failed to fetch marker colors");
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};

export const SaveColors = async (payload) => {
    const token = Cookies.get("accessToken");

    try {
        const response = await axios.post(
            `${BASE_URL}api/v1/marker-color/save-all`,
            payload, // Payload should be the second parameter for POST
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.header.code === 600) {
            return response.data.body.value;
        }

        throw new Error("Failed to save marker colors"); // Updated error message for clarity
    } catch (error) {
        console.error("Error saving colors:", error);
        return []; // Return an empty array on error
    }
};

// fetch email notification status
export const fetchEmailNotification = async (activityId) => {
    const token = Cookies.get("accessToken");

    try {
        const response = await axios.get(
            `${BASE_URL}api/v1/setting/email/status?workflowId=${activityId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return withApiError(response.data);
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};

// update email notification status
export const updateEmailNotification = async (status,activityId) => {
    const token = Cookies.get("accessToken");
    try {
        const response = await axios.patch(
            `${BASE_URL}api/v1/setting/notification/flag`,
            {
                notification:status, 
                workflowId:activityId
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return withApiError(response.data);
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};

export const addEmail = async (email, activityId) => {
    const token = Cookies.get("accessToken");
    try {
        const response = await axios.post(
            `${BASE_URL}api/v1/setting/email`,
            {
                email, 
                workflowId:activityId
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return withApiError(response.data);
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};

// get all Email
export const getAllEmail = async (activityId) => {
    const token = Cookies.get("accessToken");

    try {
        const response = await axios.get(
            `${BASE_URL}api/v1/setting/emails?workflowId=${activityId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return withApiError(response.data);
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};

// delete Email by id
export const deleteEmailById = async (id) => {
    const token = Cookies.get("accessToken");
    try {
        const response = await axios.delete(
            `${BASE_URL}api/v1/setting/email?id=${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.header.code === 600) {
            return response.data.body.value;
        }

        throw new Error("Failed to fetch marker colors");
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};


